/* ==========================================================================
   DIREVULF — the bag's own behaviour.

   Selection, saved-for-later, move-to-wishlist, the coupon field, the wishlist
   picker and the recommendations rail. It sits on top of DirevulfCart above
   rather than beside it, so there is still exactly one place in this theme
   that changes a Shopify cart.

   THE ONE RULE THIS FILE FOLLOWS
   ------------------------------
   Shopify checks out the whole cart, so "unticked" cannot mean "in the cart
   but not paid for". Unticking therefore takes the line OUT of the cart and
   keeps it on this device; ticking it puts the line back with its quantity and
   its line properties. The total on the screen is then always exactly the
   total Shopify will charge — there is no second, softer number anywhere.

   Nothing here formats money. Every amount on this page came out of Liquid,
   including the saved rows, which are fetched through the Section Rendering
   API for that reason alone.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SAVED_KEY = 'dv:bag:saved';
  var SAVED_SECTION = 'cart-saved-line';
  var WISH_SECTION = 'wishlist-card';
  var XSELL_SECTION = 'cart-recommendations';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function page() { return $('[data-dv-cart-page]'); }
  function base() { return ROOT.replace(/\/$/, ''); }

  var S = {};
  function readStrings() {
    var node = $('[data-dv-bag-strings]');
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (e) { return {}; }
  }

  /* Cart writes are serialised. Shopify's cart is one shared object, so firing
     several changes at once is how a bag ends up disagreeing with its own
     total; every action below joins this chain instead. */
  var chain = Promise.resolve();
  function queue(task) {
    chain = chain.then(task).catch(function () { /* the action reported it */ });
    return chain;
  }

  /* ------------------------------------------------------- saved-for-later */
  /* A plain list of what the shopper unticked: the variant, how many, and the
     line properties, so a Create Your Own design is not lost on the way back
     into the bag. No price is kept — a stored price would go stale, and the
     row is re-rendered from Liquid every time it is shown. */
  function readSaved() {
    try {
      var raw = window.localStorage.getItem(SAVED_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }
  function writeSaved(list) {
    try { window.localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
    return list;
  }
  function dropSaved(variantId) {
    return writeSaved(readSaved().filter(function (e) { return String(e.id) !== String(variantId); }));
  }

  function announce(message) {
    if (message && window.Direvulf && window.Direvulf.announce) window.Direvulf.announce(message);
  }

  function fetchSection(url) {
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        return html ? new DOMParser().parseFromString(html, 'text/html') : null;
      });
  }

  /* ------------------------------------------------------------- rendering */
  function renderSaved() {
    var host = $('[data-dv-bag-saved]');
    var list = $('[data-dv-bag-saved-list]');
    if (!host || !list) return Promise.resolve();

    var saved = readSaved();
    var empty = $('[data-dv-bag-empty]');
    list.innerHTML = '';
    if (!saved.length) {
      host.hidden = true;
      if (empty) empty.hidden = false;
      updateSelectedLabel();
      return Promise.resolve();
    }
    host.hidden = false;
    /* A cart that is empty because everything was unticked is not an empty
       bag, so the empty state stands down while anything is held here. */
    if (empty) empty.hidden = true;

    return Promise.all(saved.map(function (entry) {
      var url = base() + '/products/' + encodeURIComponent(entry.handle)
        + '?section_id=' + encodeURIComponent(SAVED_SECTION)
        + '&variant=' + encodeURIComponent(entry.id);
      return fetchSection(url)
        .then(function (doc) { return doc ? doc.querySelector('[data-dv-bag-saved-line]') : null; })
        .catch(function () { return null; });
    })).then(function (rows) {
      var live = $('[data-dv-bag-saved-list]');
      if (!live) return;
      rows.forEach(function (row, i) {
        if (!row) return;
        var qty = $('[data-dv-bag-saved-qty]', row);
        if (qty) qty.value = String(saved[i].quantity || 1);
        live.appendChild(row);
      });
      /* A handle that no longer resolves — the product was deleted or
         unpublished — is dropped rather than left behind as a ghost row. */
      var kept = saved.filter(function (entry, i) { return !!rows[i]; });
      if (kept.length !== saved.length) writeSaved(kept);
      updateSelectedLabel();
    });
  }

  function updateSelectedLabel() {
    var inCart = $$('[data-dv-bag-line]').length;
    var savedCount = readSaved().length;
    var out = $('[data-dv-bag-selected-text]');
    if (out && S.items_selected) {
      out.textContent = S.items_selected
        .split('%SELECTED%').join(String(inCart))
        .split('%TOTAL%').join(String(inCart + savedCount));
    }
    var all = $('[data-dv-bag-select-all]');
    if (all) {
      all.checked = inCart > 0 && savedCount === 0;
      all.indeterminate = inCart > 0 && savedCount > 0;
    }
  }

  function afterCartChange() {
    loadXsell();
    syncShipping();
    return renderSaved();
  }

  /* ------------------------------------------------------------- selection */
  function lineData(li) {
    var props = {};
    try { props = JSON.parse(li.getAttribute('data-properties') || '{}') || {}; } catch (e) { props = {}; }
    return {
      key: li.getAttribute('data-line-key'),
      id: li.getAttribute('data-variant-id'),
      handle: li.getAttribute('data-handle'),
      quantity: parseInt(li.getAttribute('data-quantity'), 10) || 1,
      properties: props
    };
  }

  function deselect(li) {
    if (!li) return Promise.resolve();
    var data = lineData(li);
    if (!data.key || !data.id || !data.handle) return Promise.resolve();
    var list = readSaved().filter(function (e) { return String(e.id) !== String(data.id); });
    list.unshift({ id: data.id, handle: data.handle, quantity: data.quantity, properties: data.properties });
    writeSaved(list);
    return window.DirevulfCart.change(data.key, 0).then(afterCartChange);
  }

  function restore(variantId) {
    var entry = readSaved().filter(function (e) { return String(e.id) === String(variantId); })[0];
    if (!entry) return Promise.resolve();
    var body = { id: Number(entry.id), quantity: entry.quantity || 1 };
    if (entry.properties && Object.keys(entry.properties).length) body.properties = entry.properties;

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error(payload.description || payload.message || 'cart-add-failed');
          return payload;
        });
      })
      .then(function () {
        dropSaved(variantId);
        return window.DirevulfCart.refresh().then(afterCartChange);
      })
      .catch(function () {
        /* Shopify refused it — sold out, or the variant no longer exists. The
           row stays saved and untouched rather than vanishing silently. */
        return renderSaved();
      });
  }

  function removeLine(key) {
    if (!key) return Promise.resolve();
    return window.DirevulfCart.change(key, 0).then(afterCartChange);
  }

  function clearCart() {
    return fetch(ROOT + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () { return window.DirevulfCart.refresh(); })
      .then(afterCartChange);
  }

  /* -------------------------------------------------------------- wishlist */
  function addToWishlist(btn) {
    if (!window.DirevulfWishlist) return;
    var price = parseInt(btn.getAttribute('data-product-price'), 10);
    window.DirevulfWishlist.add({
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      price: isNaN(price) ? null : price,
      available: btn.getAttribute('data-product-available') === 'true'
    });
    window.DirevulfWishlist.render();
  }

  /* The shopper's own saved products, rendered by the same card component the
     wishlist page uses, so there is no second card implementation here.

     Each run takes a ticket. Opening the panel while a previous render is
     still in flight would otherwise clear the list and then let both runs
     append into it, which shows every card twice. */
  var wishRun = 0;
  function loadWishlistPicker() {
    var list = $('[data-dv-bag-wishlist-list]');
    var empty = $('[data-dv-bag-wishlist-empty]');
    if (!list || !window.DirevulfWishlist) return;

    var run = ++wishRun;
    var saved = window.DirevulfWishlist.list();
    list.innerHTML = '';
    if (empty) empty.hidden = saved.length > 0;
    if (!saved.length) return;

    saved.slice(0, 6).forEach(function (entry) {
      if (!entry.handle) return;
      var url = base() + '/products/' + encodeURIComponent(entry.handle)
        + '?section_id=' + encodeURIComponent(WISH_SECTION);
      fetchSection(url).then(function (doc) {
        if (run !== wishRun) return;
        var card = doc && doc.querySelector('[data-dv-product-card]');
        var live = $('[data-dv-bag-wishlist-list]');
        if (!card || !live) return;
        var li = document.createElement('li');
        li.appendChild(card);
        live.appendChild(li);
        document.dispatchEvent(new CustomEvent('dv:section:loaded'));
        window.DirevulfWishlist.render();
      }).catch(function () { /* one card missing is not a broken panel */ });
    });
  }

  /* ------------------------------------------------------------ cross-sell */
  /* Shopify's own recommendation engine, for something already in the bag.
     Complementary first, because that is the merchant's own pairing; related
     is Shopify's own fallback. If neither returns anything the panel stays
     hidden rather than being filled with something this file chose. */
  function recommendationsFor(productId, intent) {
    var url = ROOT + 'recommendations/products?section_id=' + XSELL_SECTION
      + '&product_id=' + encodeURIComponent(productId)
      + '&limit=4&intent=' + intent;
    return fetchSection(url).then(function (doc) {
      return doc ? doc.querySelector('[data-dv-xsell]') : null;
    });
  }

  function loadXsell() {
    var host = $('[data-dv-bag-xsell]');
    var slot = $('[data-dv-bag-xsell-slot]');
    if (!host || !slot) return;
    var first = $('[data-dv-bag-line]');
    var id = first && first.getAttribute('data-product-id');
    slot.innerHTML = '';
    host.hidden = true;
    if (!id) return;

    recommendationsFor(id, 'complementary')
      .then(function (found) { return found || recommendationsFor(id, 'related'); })
      .then(function (found) {
        var liveSlot = $('[data-dv-bag-xsell-slot]');
        var liveHost = $('[data-dv-bag-xsell]');
        if (!found || !liveSlot || !liveHost) return;
        liveSlot.appendChild(found);
        liveHost.hidden = false;
        document.dispatchEvent(new CustomEvent('dv:section:loaded'));
        if (window.DirevulfWishlist) window.DirevulfWishlist.render();
      })
      .catch(function () { /* no rail rather than a broken one */ });
  }

  /* --------------------------------------------------------------- shipping */
  /* delivery.js owns the quote — it is the one place that asks Shopify what
     delivery costs. The bag owns what a quote MEANS for the total: it stores
     the figure on the cart as an attribute and re-renders, so Liquid formats
     the money and this file never does.

     Nothing here decides a rate. If Shopify quotes nothing, the figure is
     cleared but the address is kept, so the bag can say "no delivery option
     for this address" rather than asking again for a pincode it already has. */
  function storeShipping(detail) {
    var rate = detail && detail.rate;
    var attributes = rate
      ? {
          dv_ship_pin: detail.pin || '',
          dv_ship_country: detail.country || '',
          dv_ship_province: detail.province || '',
          dv_ship_rate: String(rate.minor),
          dv_ship_name: rate.name || ''
        }
      : {
          /* The address stays: the shopper gave it, and it is the difference
             between "tell us where" and "we cannot deliver there". Only the
             figure goes, because there isn't one. */
          dv_ship_pin: detail.pin || '',
          dv_ship_country: detail.country || '',
          dv_ship_province: detail.province || '',
          dv_ship_rate: '',
          dv_ship_name: ''
        };

    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart-attributes-failed');
        return window.DirevulfCart.refresh();
      })
      .then(function () { return renderSaved(); });
  }

  /* Shopify's own rates can depend on what is in the bag, so the quote is
     refreshed after every change. What is already stored — the address and
     the figure together — is compared with what came back, and the cart is
     only written when they actually differ, so this settles rather than
     looping. */
  function syncShipping() {
    var box = $('[data-dv-deliver]');
    if (!box || !window.DirevulfDelivery) return;
    if (!(box.getAttribute('data-pin') || '').trim()) return;
    if (!$$('[data-dv-bag-line]').length) return;
    window.DirevulfDelivery.check(box, true);
  }

  document.addEventListener('dv:delivery:quote', function (event) {
    if (!page()) return;
    var detail = event.detail || {};
    var box = $('[data-dv-deliver]');
    /* The address is part of what is stored, so a new address with the same
       answer — including no answer at all — still has to be written. Each
       field is compared on its own; nothing is glued together, so no value
       can ever be mistaken for a different one split another way. */
    function held(name) { return box ? (box.getAttribute(name) || '') : ''; }
    var same = held('data-rate') === (detail.rate ? String(detail.rate.minor) : '')
      && held('data-pin') === (detail.pin || '')
      && held('data-country') === (detail.country || '')
      && held('data-province') === (detail.province || '');
    if (same) return;
    queue(function () { return storeShipping(detail); });
  });

  /* --------------------------------------------------------------- wiring */
  document.addEventListener('change', function (event) {
    if (!page()) return;

    var qty = event.target.closest('[data-dv-bag-qty]');
    if (qty) {
      var value = parseInt(qty.value, 10);
      if (isNaN(value) || value < 1) value = 1;
      var key = qty.getAttribute('data-line-key');
      queue(function () { return window.DirevulfCart.change(key, value).then(afterCartChange); });
      return;
    }

    var savedQty = event.target.closest('[data-dv-bag-saved-qty]');
    if (savedQty) {
      var row = savedQty.closest('[data-dv-bag-saved-line]');
      var n = parseInt(savedQty.value, 10);
      if (!row || isNaN(n) || n < 1) return;
      var savedId = row.getAttribute('data-variant-id');
      writeSaved(readSaved().map(function (e) {
        if (String(e.id) === String(savedId)) e.quantity = n;
        return e;
      }));
      return;
    }

    var tick = event.target.closest('[data-dv-bag-select]');
    if (tick) {
      if (!tick.checked) {
        var li = tick.closest('[data-dv-bag-line]');
        queue(function () { return deselect(li); });
      }
      return;
    }

    var back = event.target.closest('[data-dv-bag-restore]');
    if (back) {
      if (back.checked) {
        var backId = back.closest('[data-dv-bag-saved-line]').getAttribute('data-variant-id');
        queue(function () { return restore(backId); });
      }
      return;
    }

    var all = event.target.closest('[data-dv-bag-select-all]');
    if (all) {
      if (all.checked) {
        readSaved().forEach(function (entry) {
          queue(function () { return restore(entry.id); });
        });
      } else {
        $$('[data-dv-bag-line]').forEach(function (node) {
          queue(function () { return deselect(node); });
        });
      }
    }
  });

  document.addEventListener('click', function (event) {
    if (!page()) return;

    var remove = event.target.closest('[data-dv-bag-remove]');
    if (remove) {
      event.preventDefault();
      var removeKey = remove.getAttribute('data-line-key');
      queue(function () { return removeLine(removeKey); });
      return;
    }

    var move = event.target.closest('[data-dv-bag-move]');
    if (move) {
      event.preventDefault();
      addToWishlist(move);
      announce(S.moved_to_wishlist || '');
      var moveKey = move.getAttribute('data-line-key');
      queue(function () { return removeLine(moveKey); });
      return;
    }

    var backBtn = event.target.closest('[data-dv-bag-restore-btn]');
    if (backBtn) {
      event.preventDefault();
      var id = backBtn.closest('[data-dv-bag-saved-line]').getAttribute('data-variant-id');
      queue(function () { return restore(id); });
      return;
    }

    var dropBtn = event.target.closest('[data-dv-bag-saved-remove]');
    if (dropBtn) {
      event.preventDefault();
      dropSaved(dropBtn.closest('[data-dv-bag-saved-line]').getAttribute('data-variant-id'));
      renderSaved();
      return;
    }

    /* Everything to the wishlist, then one clear — not one cart write per
       line, which is how a bag and its total drift apart. */
    var wishAll = event.target.closest('[data-dv-bag-wishlist-all]');
    if (wishAll) {
      event.preventDefault();
      $$('[data-dv-bag-move]').forEach(addToWishlist);
      announce(S.moved_to_wishlist || '');
      queue(clearCart);
      return;
    }

    var clearBtn = event.target.closest('[data-dv-bag-remove-all]');
    if (clearBtn) {
      event.preventDefault();
      queue(clearCart);
      return;
    }

    /* The sticky bar's "View details" brings the billing panel into view. It
       is the same panel, not a second copy of the numbers. */
    var details = event.target.closest('[data-dv-bag-details]');
    if (details) {
      event.preventDefault();
      var billing = $('[data-dv-bag-billing]');
      if (billing) billing.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* Shopify's own /discount/<code> route validates the code against this cart
     and applies it. This theme never decides whether a code is good, and never
     shows a saving Shopify has not granted. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-dv-bag-coupon]');
    if (!form) return;
    event.preventDefault();
    var input = $('input[name="code"]', form);
    var code = input && input.value.trim();
    if (!code) return;
    window.location.assign(base() + '/discount/' + encodeURIComponent(code)
      + '?redirect=' + encodeURIComponent(ROOT + 'cart'));
  });

  /* `toggle` does not bubble, so this listens in the capture phase. */
  document.addEventListener('toggle', function (event) {
    var acc = event.target.closest && event.target.closest('[data-dv-bag-wishlist]');
    if (acc && acc.open) loadWishlistPicker();
  }, true);

  document.addEventListener('dv:wishlist:change', function () {
    if (page() && $('[data-dv-bag-wishlist]') && $('[data-dv-bag-wishlist]').open) loadWishlistPicker();
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (!page()) return;
    S = readStrings();
    renderSaved();
    loadXsell();
    /* delivery.js checks a pincode it already has on its own DOMContentLoaded,
       so a signed-in shopper's total is complete on arrival with nothing
       typed. Nothing to kick off here. */
  });
})();
